import TimePeriodSwitcher from './TimePeriodSwitcher';

export default TimePeriodSwitcher;
